module.exports = __webpack_public_path__ + "assets/done@3x.1f6952a9ea64605819178c0719f596e5.png";